import { getText } from 'src/ConsentManagement/TranslationService';

type ToggleSwitchModel = {
  uid: string;
  isChecked: boolean;
  onChangeHandler: (event: any) => void;
};

export const ToggleSwitch = ({ uid, isChecked, onChangeHandler }: ToggleSwitchModel) => (
    <div class="col-option">
        <div class="toggle-cell">
            <input name={uid} type="checkbox" class="toggle" id={uid} checked={isChecked} onChange={onChangeHandler} />
            <span class="toggle-text-on">{getText(`on`)}</span>
            <span class="toggle-text-off">{getText(`off`)}</span>
            <label class="toggle-label-container" for={uid}>
                <span class="on"></span>
                <span class="off"></span>
            </label>
        </div>
    </div>
);
